export class InspectionService {
  url = "https://node.flowautobody.com";
  public inspectionForm: any;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {}

  public getInspections() {
    return this.sendRequest(this.url + "/inspections", "GET");
  }

  public async getInspectionById(estimateId: string) {
    const response = await fetch(
      this.url + `/inspections/inspectionByEstimateId/${estimateId}?type=PRE`
    );
    if (!response.ok) {
      return [];
    } else {
      return response.json();
    }
  }

  public async getInspectionsChecks() {
    const response = await fetch(this.url + `/inspections/checks`);
    if (!response.ok) {
      throw new Error("Data could not be fetched!");
    } else {
      return response.json();
    }
  }

  sendRequest(url: string, method: string, data?: any) {
    let requestOptions: any = {
      method: method,
      headers: { "Content-Type": "application/json" },
    };
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }
}
